'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024$0024anon$0024167 from "./presto.types$-Account-Name$$anon$167.js";
var $p;
/** @constructor */
function $c_Lpresto_types$AccountName$() {
  this.c3Y = null;
  this.c3Z = false;
  this.c3W = null;
  this.c3X = false;
  this.c40 = null;
  this.c41 = false;
}
export { $c_Lpresto_types$AccountName$ as $c_Lpresto_types$AccountName$ };
$p = $c_Lpresto_types$AccountName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$AccountName$;
/** @constructor */
function $h_Lpresto_types$AccountName$() {
}
export { $h_Lpresto_types$AccountName$ as $h_Lpresto_types$AccountName$ };
$h_Lpresto_types$AccountName$.prototype = $p;
$p.cs0 = (function() {
  if ((!this.c3Z)) {
    this.c3Y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c3Z = true;
  }
  return this.c3Y;
});
$p.adp = (function() {
  if ((!this.c3X)) {
    this.c3W = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c3X = true;
  }
  return this.c3W;
});
$p.cIR = (function() {
  if ((!this.c41)) {
    this.c40 = new $j_presto$002etypes$0024$002dAccount$002dName$0024$0024anon$0024167.$c_Lpresto_types$AccountName$$anon$167(this);
    this.c41 = true;
  }
  return this.c40;
});
var $d_Lpresto_types$AccountName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$AccountName$, "presto.types$AccountName$", ({
  Yr: 1,
  D: 1
}));
export { $d_Lpresto_types$AccountName$ as $d_Lpresto_types$AccountName$ };
var $n_Lpresto_types$AccountName$;
function $m_Lpresto_types$AccountName$() {
  if ((!$n_Lpresto_types$AccountName$)) {
    $n_Lpresto_types$AccountName$ = new $c_Lpresto_types$AccountName$();
  }
  return $n_Lpresto_types$AccountName$;
}
export { $m_Lpresto_types$AccountName$ as $m_Lpresto_types$AccountName$ };
//# sourceMappingURL=presto.types$-Account-Name$.js.map
